import React from 'react';

import { Apify } from '../Apify';
import Logo from './Logo';
import { R } from '../routes';


var LogoAndInfo = (props) => {
	let size = props.logo_size || 60;
	let css_name = props.css_name || "ad_chart_h1";
	let css_ticker = props.css_ticker || "ad_chart_h2";
	let name = props.name;
	if(props.add_ellipsis2name) {
		name = (
			<span className="text-overflow-dynamic-container">
				<span className="text-overflow-dynamic-ellipsis ">
					{props.name}
				</span>
			</span>
		);
	}

	return (
		<div className="d-flex flex-grow-1">
			<div className="d-flex">
				<Logo size={size} className="my-auto" exchange={props.exchange} ticker={props.ticker}/>
			</div>
			<div className="d-flex flex-grow-1 flex-column align-self-center pl-2">
				<div className={css_name}>
					{name}
				</div>
				<div className={css_ticker}>
					{props.ticker}
				</div>
			</div>
		</div>
	);
}

export default Apify("/z/stock_info")
	.with_query_from_props(props => ({exchange: props.exchange, ticker: props.ticker, lang: R.get_current_language()}))
	.with_props_from_response(response => ({name: response.Name}))
	.wrap(LogoAndInfo);



// WEBPACK FOOTER //
// ./src/c/LogoAndInfo.js